import SectionHeading from "./SectionHeading";

const stats = [
  { value: "2000+", label: "每日热点瓜点" },
  { value: "38万+", label: "活跃吃瓜用户" },
  { value: "99.9%", label: "内容审核通过率" },
  { value: "24h", label: "全天实时跟进" },
];

const values = [
  {
    icon: "ri-focus-3-fill",
    title: "真实优先",
    desc: "严格审核来源，去伪存真，拒绝博眼球的标题党，只做值得围观的热点。",
  },
  {
    icon: "ri-speed-up-line",
    title: "实时跟进",
    desc: "热点从不等人，我们用最快速度聚合事件短视频，让你始终领先一步。",
  },
  {
    icon: "ri-shield-check-fill",
    title: "版权尊重",
    desc: "聚合公开内容的同时尊重原创权益，营造健康理性的吃瓜氛围。",
  },
  {
    icon: "ri-compass-3-fill",
    title: "内容多元",
    desc: "从明星八卦到民生趣闻，多领域覆盖，满足每一位瓜友的兴趣偏好。",
  },
];

function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <SectionHeading
              eyebrow="关于我们"
              title="专注聚合，陪你把瓜吃明白"
            />
            <div className="space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
              <p>
                吃瓜视频网诞生于对热点内容聚合的需求。在这个信息爆炸的时代，热点瓜点散落在全网各处，追起来既费时又容易错过关键信息。
              </p>
              <p>
                我们把自己定位成"瓜田守望者"——持续扫描全网热点事件，将事件短视频、焦点视频与话题内容进行聚合、分类和梳理，让你在一个站点里就能随时掌握最新动态，快速围观事件现场。
              </p>
              <p>
                我们不追求流量至上，而是坚持以真实、及时、多元为内容原则，用结构清晰的方式呈现每一颗"瓜"，陪你把每一场热闹都看明白。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl border border-background-200 bg-background-100 p-4 text-center"
                >
                  <p className="font-heading text-xl md:text-2xl text-primary-700">
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl border border-background-200 bg-background-100 p-5 transition-all hover:-translate-y-1 hover:bg-background-50"
              >
                <span className="grid h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={`${v.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 text-base font-medium text-foreground-900">
                  {v.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;